import constants from "../../core/constants";

class Controller {
  constructor($injector, $stateParams) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.Sections = $injector.get("Sections");
    this.BackupPlan = $injector.get("BackupPlan");
    this.BackupPlanTransforms = $injector.get("BackupPlanTransforms");

    this.onUpdateEvent = this.Events.getUpdateEvent("backupPlan");

    this.sections = this.Sections.plansSections;
  }
  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onUpdate = (options) => {
      const params = {};
      params[options.key] =
        typeof options.value !== "undefined"
          ? options.value
          : options.name
          ? options.name._id
          : null;
      if (options.key === "wage") {
        params[options.key] = options.value * constants.currencyBy;
      }

      this.BackupPlan.update(this.$stateParams.id, params).$promise.then(
        () => {
          this.backupPlan[options.key].isDisabled = true;
          this.Events.emit(
            showNotificationEvent,
            this.Messages.updateMessage("backup plan", options.key)
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    this.BackupPlan.get(this.$stateParams.id).$promise.then((response) => {
      this.backupPlan = this.BackupPlanTransforms.justify(response);
    });
    this.Events.on(this.onUpdateEvent, onUpdate);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/backupPlan/backupPlan.controller.js